import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { AuthService } from "../../services/auth.service";
import { AuthToken } from "../auth/auth.token";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  public auth: AuthToken = null;

  constructor(private router: Router, private authService: AuthService) {
    this.auth = authService.getAuth();
  }

  isRoot: boolean;

  ngOnInit(): void {
    this.listenRouterEvent();
  }

  /**
   * @description Listen to changes in router event to set if current URL is root
   */
  private listenRouterEvent(): void {
    this.setIsRoot(this.router.url);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((routeEvent) => {
        this.setIsRoot(routeEvent["url"]);
      });
  }

  private setIsRoot(url: string): void {
    this.isRoot = url === "/" ? true : false;
  }

  toggleSidebar(): void {}
}
